import React from "react";
import { Chart } from "react-charts";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/material";

const Line = ({ elasticityCurve }) => {
    const theme = useTheme();

    const series = [
        {
            data: elasticityCurve ? elasticityCurve.map(i => ({ interest: i.interest, probability: i.standard })) : [],
            label: "Common"
        },
        {
            data: elasticityCurve ? elasticityCurve.map(i => ({ interest: i.interest, probability: i.client })) : [],
            label: "Client"
        }
    ];

    const primaryAxis = React.useMemo(
        () => ({
            getValue: (datum) => { console.log(datum);  return datum.interest; },
        }),
        []
    );

    const secondaryAxes = React.useMemo(
        () => [
            {
                getValue: (datum) => { console.log(datum); return datum.probability; },
            },
        ],
        []
    );

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                <Box sx={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: theme.palette.primary.main, border: "none" }}></Box>
                <Box>Common</Box>
                <Box sx={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: theme.palette.secondary.main, border: "none" }}></Box>
                <Box>Client</Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
                <Box sx={{writingMode: "vertical-rl", transform: "rotate(180deg)" }}>Probability to buy</Box>
                <Box sx={{ width: "100%", minHeight: "300px", flexGrow: "1" }}>
                    <Chart
                        options={{
                            data: series,
                            primaryAxis,
                            secondaryAxes,
                            defaultColors: [theme.palette.primary.main, theme.palette.secondary.main]
                        }}
                    />
                </Box>
            </Box>
            <Box>
                Interest rate
            </Box>
        </Box>
        
    );
};

export default Line;